import { useContext } from "react";
import ReactBellIcon from "react-bell-icon";
import { toast } from "react-toastify";
import { Store } from "../Store";
import {
  getLocalTimeFormatted,
  turkishCurrencyFormatterNoPrecision,
} from "../utils";
import CartScreenTouchItemRelativeForAnswer from "./CartScreenTouchItemRelativeForAnswer";

export default function CartScreenTouchItem(props) {
  const {
    isPartialPayment,
    ozetle,
    item,
    relativeItems,
    cart,
    setSelectedIndex,
    setShowAddCard,
    table,
    index,
  } = props;

  const { dispatch: ctxDispatch } = useContext(Store);

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div
        className={
          item.customerName || cart.description || isPartialPayment || ozetle
            ? "btn-group "
            : "btn-group backgroung-image-gradient"
        }
        style={{
          marginBottom: "0.3rem",
          marginLeft: "0.3rem",
          marginRight: "0.3rem",
        }}
      >
        {!isPartialPayment &&
          !ozetle &&
          (item.customerName || cart.description) && (
            <div
              className="rounded-start btn-success"
              style={{
                height: "40px",
                width: "30px",
                overflow: "hidden",
                display: "flex",
                justifyContent: "flex-start",
                border: "1px solid #DDD",
              }}
            >
              <p
                className={
                  item.isPartialPaid
                    ? "text-white small-font p-2 m-0 text-bold"
                    : "text-white small-font p-2 m-0 text-bold"
                }
                style={{
                  writingMode: "vertical-rl",
                  textOrientation: "mixed",
                  textAlign: "center",
                  opacity: "0.8",
                }}
              >
                {(item.customerName || cart.description)
                  .split(" ")[0]
                  .substring(0, 6)}
              </p>
            </div>
          )}
        {!cart.isStaffMeal &&
          !ozetle &&
          isPartialPayment &&
          !item.isPartialPaid &&
          !item.isGift && (
            <div
              className={
                "partialPay " +
                (item.isPartialPayment ? "text-danger" : "text-primary")
              }
              style={{
                height: "40px",
                aspectRatio: "1/1",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
              }}
              onClick={() =>
                ctxDispatch({
                  type: "CART_PARTIAL_PAYMENT_ITEM_CHECK",
                  payload: {
                    isPartialPayment: !item.isPartialPayment,
                    index,
                    tableNum: table,
                  },
                })
              }
            >
              <i
                style={{ fontSize: "24px" }}
                className={
                  item.isPartialPayment
                    ? "fas fa-check-square"
                    : "fas fa-minus-square"
                }
              ></i>
            </div>
          )}

        <div
          className={
            "text-dark  ps-2 " +
            `${!item.delivered && item.alert ? "hoverPoiner " : ""}`
          }
          style={{
            height: "40px",
            aspectRatio: "1/1",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-start",
            position: "relative",
            borderTop: "0px",
            borderLeft: "0px",
            borderRight: "0px",
            borderBottom: "1px solid #DDD",
            borderBottomLeftRadius: "0px",
          }}
          onClick={() => {
            if (!item.delivered && item.alert) {
              ctxDispatch({
                type: "CARTITEM_SET_DELIVERED",
                payload: {
                  tableNum: cart.tableNum,
                  itemCode: item.itemCode,
                },
              });
            }
          }}
        >
          <div id="time-and-bell-part">
            {!item.delivered && item.alert && !item.isPartialPaid && (
              <div
                className="border border-danger rounded-circle bg-white "
                style={{
                  position: "absolute",
                  top: "2px",
                  right: "5px",
                  width: "19px",
                  height: "19px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <ReactBellIcon
                  active={false}
                  animate={true}
                  color="#dc3545"
                  width="15"
                  height="15"
                />
              </div>
            )}
            <span
              className={
                item.isPartialPaid
                  ? "small-font text-bold text-secondary"
                  : "small-font text-bold"
              }
            >
              {getLocalTimeFormatted(item.createdAt)}{" "}
            </span>
          </div>
        </div>

        <div
          onClick={() => {
            if (ozetle) {
              toast.info("Bu işlemi yapmak için özet modundan çıkmalısınız");
              return;
            }
            if (!item.isPartialPaid) {
              setSelectedIndex(index);
              setShowAddCard(true);
            } else {
              toast.error("Ödendi, değişiklik yapılmaz!");
            }
          }}
          className="btn btn-outline-success text-dark rounded"
          style={{
            height: "40px",
            aspectRatio: "5/1",
            textAlign: "start",
            overflow: "hidden",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "baseline",
            borderTop: "0px solid #DDD",
            borderLeft: "0px solid #DDD",
            borderRight: "0px solid #DDD",
            borderBottom: "1px solid #ddd",
            borderRadius: "0px",
          }}
        >
          <div>
            <span
              className={
                item.isPartialPaid ? "text-bold text-secondary" : "text-bold"
              }
            >
              {ozetle ? item.quantity2 : item.quantity}
            </span>
            &nbsp;
            <span
              className={
                item.isPartialPaid ? "textDecorationLine text-secondary" : ""
              }
            >
              {item.feature ? item.feature.name + " " : ""}
              {item.name}
            </span>
            &nbsp;
            <span className="text-bold text-muted">
              {turkishCurrencyFormatterNoPrecision(
                item.price + (item.feature ? item.feature.price : 0)
              )}
            </span>
          </div>
          <div>
            <span>
              {item.answers
                ?.flatMap((a) => a.answers)
                .reduce((a, c) => a + c.cost, 0) > 0 && (
                <>
                  <span className="text-muted" style={{ fontSize: "12px" }}>
                    +
                    {turkishCurrencyFormatterNoPrecision(
                      item.answers
                        ?.flatMap((a) => a.answers)
                        .reduce((a, c) => a + c.cost, 0)
                    )}
                  </span>
                  &nbsp;&nbsp;
                </>
              )}
              <span
                className={
                  item.isPartialPaid
                    ? "textDecorationLine text-bold text-secondary"
                    : item.isGift || cart.isStaffMeal
                    ? "isGift text-bold text-warning"
                    : "text-bold text-warning"
                }
              >
                {turkishCurrencyFormatterNoPrecision(
                  ((item.feature ? item.feature.price : 0) + item.price) *
                    item.quantity
                )}
              </span>
            </span>
          </div>
        </div>
      </div>

      {!ozetle &&
        relativeItems &&
        relativeItems.map((a) => (
          <CartScreenTouchItemRelativeForAnswer
            key={item._id + a._id}
            item={item}
            cart={cart}
            answer={a}
            ozetle={ozetle}
          />
        ))}
    </div>
  );
}
